/* Live */
export const apiUrl = "https://fleetapi.nsnemo.com/apiv1/";
export const downloadUrl = "https://fleetapi.nsnemo.com/";
export const baseUrl = "https://hrms.nsnemo.com/";

/* export const apiUrl = "http://localhost:8001/apiv1/";
export const downloadUrl = "http://localhost:8001/"; 
export const baseUrl = "http://localhost:3000/"; */


export const s3Link = 'https://nsnemo.s3.us-east-1.amazonaws.com/';
export const adminlimit = 10;
export const calendarFormat = "dd-MMM-yyyy";